export default __webpack_public_path__ + "780c99eda669683ea4980da92f34406a.svg";